<template>
    <div>
        <img class="logo" src="@/assets/img/logo.svg" alt="">

        <Backgrounds :backgroundIndex="background" />

        <transition name="swipe">
            <div class="swipe" v-if="swipeVisible">
                <div class="swipe__inner">
                    <img src="@/assets/img/arrow_swipe.svg" />
                    <div>Swipe up</div>
                </div>
            </div>
        </transition>

        <div class="slides">
            <div class="slides__text-shadow"></div>

            <div class="slide slide--intro" background="1">
                <img class="slide__logo" src="@/assets/img/logo.svg" alt="">
            </div>

            <div class="slide slide--text" background="1" dot="1">
                <div class="slide__content">
                    <div class="slides__dots" :class="`slides__dots--active-${currentTextSlide}`">
                        <ul>
                            <li
                                v-for="(n) in numberOfDots"
                                :key="n"
                                :class="{'active': currentSlideDotIndex === n}"
                                @click="goToSlide(n + 1)"
                            ></li>
                        </ul>
                    </div>

                    <h1 class="title">
                        Hi, wij zijn Nomilk2day
                    </h1>
                    <div class="slide__content__text">
                        <p>
                            Wij verbinden ambitieuze organisaties met talentvolle professionals
                            in de agri, food &amp; industry. Vanuit gedeelde ambitie,
                            want wij geloven dat dit de sterkste factor is naar succes.
                        </p>
                    </div>
                </div>
            </div>

            <div class="slide slide--text" background="1" dot="2">
                <div class="slide__content">
                    <h1 class="title">
                        Connecting ambitions
                    </h1>
                    <div class="slide__content__text">
                        <p>
                            Connecting Ambitions. Dat is onze visie. Waarbij wij jou helpen jouw ambitie na te streven.
                            En je ondersteunen als deze verandert of stagneert.
                            Dat is de drijfveer van Nomilk2day.
                        </p>
                    </div>
                </div>
            </div>

            <div class="slide slide--text" background="1" dot="3">
                <div class="slide__content">
                    <h1 class="title">
                        Ambitieuze organisaties
                    </h1>
                    <div class="slide__content__text">
                        <p>
                            Jouw organisatie heeft ambities. Jij zoekt mensen die deze
                            waarmaken en je verder helpen. Nomilk2day
                            helpt jou vandaag aan toptalent. Zo maak jij morgen het verschil.
                        </p>
                    </div>
                </div>
            </div>

            <div class="slide slide--text" background="1" dot="4">
                <div class="slide__content">
                    <h1 class="title">
                        Talentvolle professionals
                    </h1>
                    <div class="slide__content__text">
                        <p>
                            Je bent een talentvolle professional. Gedreven
                            door ambitie werk jij aan jouw carrière. Nomilk2day
                            verbindt jou aan organisaties. In elke fase van je
                            loopbaan. Zodat jij jouw ambities kunt waarmaken.
                        </p>
                    </div>
                </div>
            </div>

            <div class="slide slide--text" background="2" dot="5">
                <div class="slide__content">
                    <h1 class="title">
                        Verbindend
                    </h1>
                    <div class="slide__content__text">
                        <p>
                            Wij brengen organisaties én professionals bij elkaar.
                            Om samen hun doelen te realiseren. Met altijd de gedeelde
                            ambities als verbindende factor.
                        </p>
                    </div>
                </div>
            </div>

            <div class="slide slide--text" background="3" dot="6">
                <div class="slide__content">
                    <h1 class="title">
                        Daadkrachtig
                    </h1>
                    <div class="slide__content__text">
                        <p>
                            We zijn daadkrachtig. Of het nou gaat om werving &amp; selectie,
                            detachering of interim. Daar hoort het maken van keuzes bij. Waarbij
                            wij niet bang zijn om ijzersterke combinaties te maken die je op voorhand
                            niet zou verwachten.
                        </p>
                    </div>
                </div>
            </div>

            <div class="slide slide--text" background="4" dot="7">
                <div class="slide__content">
                    <h1 class="title">
                        Ambitieus
                    </h1>
                    <div class="slide__content__text">
                        <p>
                            Iedereen heeft ambitie. Wij ook. Daarom verbinden wij ons expliciet
                            aan organisaties en professionals met net zulke grote ambities als wij.
                            Zo helpen wij elkaar aan groei. Wordt iedereen blij van. Klaar om in gesprek
                            te gaan? Dan bewijzen wij het vervolgens door het te doen.
                        </p>
                    </div>
                </div>
            </div>

            <div class="slide slide--end" background="4">
                <div class="slide__content">
                    <div>
                        <h2 class="title">
                            Wat is jouw ambitie?
                        </h2>

                        <a href="tel:0382020190" class="btn">
                            <span class="btn__arrow">
                                <img src="@/assets/img/arrow.svg" alt="">
                            </span>
                            <span class="btn__text">
                                Neem contact op
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Hammer from 'hammerjs';
import { TimelineMax, gsap } from 'gsap';
import Backgrounds from '@/components/Backgrounds.vue';

export default {
    data() {
        return {
            swipeVisible: true,
            currentSlide: 0,
            showScrollable: true,
            lastSlide: 8,
            lock: false,
            numberOfDots: 0,
            currentSlideDotIndex: 0,
            background: 1,
        };
    },
    components: {
        Backgrounds,
    },
    computed: {
        currentTextSlide() {
            return this.currentSlide - 1;
        },
    },
    mounted() {
        this.numberOfDots = this.$el.querySelectorAll('[dot]').length;

        const hammertime = new Hammer(this.$el.querySelector('.slides'));

        hammertime.get('pan').set({ direction: Hammer.DIRECTION_ALL });
        hammertime.get('swipe').set({ direction: Hammer.DIRECTION_ALL });

        hammertime.on('pan', (ev) => {
            if (this.swipeVisible) {
                gsap.to('.swipe', {
                    duration: 0.3,
                    y: 20 * ev.velocityY,
                });
            }
        });

        hammertime.on('panend', () => {
            if (this.swipeVisible) {
                gsap.to('.swipe', {
                    duration: 0.3,
                    y: 0,
                });
            }
        });

        hammertime.on('swipe', (ev) => {
            if (ev.direction === 8 || ev.direction === 2) {
                this.animateTo('down');
            } else if (ev.direction === 16 || ev.direction === 4) {
                this.animateTo('up');
            }
        });
    },
    methods: {
        goToSlide(n) {
            let direction = 'up';

            if (n > this.currentSlide) {
                direction = 'down';
            }

            this.currentSlide = n;
            this.animateTo(direction);
        },
        animateTo(direction) {
            if (this.lock) {
                return;
            }

            this.lock = true;

            const tl = new TimelineMax({
                onComplete: () => {
                    this.lock = false;
                },
            });
            tl.addLabel('start');

            const $currentSlide = this.$el.querySelectorAll('.slide--text')[this.currentSlide - 1];

            if (direction === 'down') {
                if (this.currentSlide === this.$el.querySelectorAll('.slide--text').length + 1) {
                    return;
                }

                this.currentSlide += 1;

                if (this.currentSlide === this.lastSlide) {
                    gsap.to('.slide--end', {
                        duration: 0.35,
                        x: 0,
                        autoAlpha: 1,
                    });

                    gsap.to($currentSlide, {
                        autoAlpha: 0,
                    });

                    gsap.to('.logo', {
                        autoAlpha: 0,
                    });

                    gsap.to('.slides__dots', { duration: 0.3, autoAlpha: 0 });
                }

                if (this.currentSlide === 1) {
                    this.swipeVisible = false;
                    tl.to(this.$el.querySelectorAll('.slide--text'), 0.0001, { autoAlpha: 1 }, 'start');
                    tl.to('.slides__text-shadow', 0.3, { height: '100%' }, 'start');
                    tl.to('.bgs', 0.6, { scale: 1 }, 'start');

                    const position = this.$el.querySelector('.slide__logo').getBoundingClientRect();
                    const logoTl = new TimelineMax();
                    logoTl.to('.slide__logo', { autoAlpha: 0, duration: 0.0111 });
                    logoTl.to('.logo', { autoAlpha: 1, duration: 0.0111 });
                    logoTl.fromTo('.logo', {
                        top: position.y,
                        left: position.x,
                        width: position.width,
                    }, {
                        top: 20,
                        left: 20,
                        width: 50,
                    });

                    tl.add(logoTl, 'start');

                    tl.addLabel('text', '-=0.2');

                    tl.to('.slides__dots', { duration: 0.3, autoAlpha: 1 }, 'text+=0.5');
                }
            } else if (direction === 'up') {
                if (this.currentSlide <= 0) {
                    this.currentSlide = 0;
                    return;
                }


                this.currentSlide -= 1;

                if (this.currentSlide === 0) {
                    this.swipeVisible = true;
                    tl.to(this.$el.querySelectorAll('.slide--text'), { duration: 0.0001, autoAlpha: 0 }, 'start');
                    tl.to('.slides__text-shadow', { height: 0, duration: 0.3 }, 'start');
                    tl.to('.bg', { scale: 1.3, duration: 0.6 }, 'start');
                    tl.to('.slides__dots', { duration: 0.3, autoAlpha: 0 }, 'start');

                    const position = this.$el.querySelector('.slide__logo').getBoundingClientRect();
                    const logoTl = new TimelineMax();
                    logoTl.to('.logo', {
                        top: position.y,
                        left: position.x,
                        width: position.width,
                    });
                    logoTl.to('.slide__logo', { autoAlpha: 1, duration: 0.0111 });
                    logoTl.to('.logo', { autoAlpha: 0, duration: 0.0111 });

                    tl.add(logoTl, 'start');
                    tl.addLabel('text', '-=0.2');
                    tl.addLabel('text');
                }
            }

            const $nextSlide = this.$el.querySelectorAll('.slide--text')[this.currentSlide - 1];

            if (!$nextSlide) {
                return;
            }

            const dotIndex = Number($nextSlide.getAttribute('dot'));

            if (dotIndex) {
                this.currentSlideDotIndex = dotIndex;
            }

            this.background = Number($nextSlide.getAttribute('background'));

            if (direction === 'down') {
                if ($currentSlide) {
                    gsap.killTweensOf($currentSlide.querySelectorAll('.slide__content__text, .title'));

                    tl.to(
                        $currentSlide.querySelectorAll('.slide__content__text, .title'),
                        {
                            y: -50,
                            autoAlpha: 0,
                            duration: 0.35,
                            stagger: 0,
                        },
                        'text',
                    );
                }

                if ($nextSlide) {
                    gsap.killTweensOf($nextSlide.querySelectorAll('.slide__content__text, .title'));

                    tl.fromTo(
                        $nextSlide.querySelectorAll('.slide__content__text, .title'),
                        {
                            y: 50,
                            autoAlpha: 0,
                        },
                        {
                            y: 0,
                            autoAlpha: 1,
                            stagger: 0,
                            duration: 0.35,
                        },
                        'text',
                    );
                }
            } else if (direction === 'up') {
                if (this.currentSlide === this.lastSlide - 1) {
                    gsap.to('.slide--end', {
                        duration: 0.35,
                        x: '100%',
                        autoAlpha: 0,
                    });

                    gsap.to('.slides__dots', { duration: 0.3, autoAlpha: 1 });
                    gsap.to($nextSlide, {
                        autoAlpha: 1,
                    });

                    gsap.to('.logo', {
                        autoAlpha: 1,
                    });

                    return;
                }

                if ($currentSlide) {
                    gsap.killTweensOf($currentSlide.querySelectorAll('.slide__content__text, .title'));

                    tl.to(
                        $currentSlide.querySelectorAll('.slide__content__text, .title'),
                        {
                            y: 50,
                            autoAlpha: 0,
                            duration: 0.35,
                            stagger: 0,
                        },
                        'text',
                    );
                }

                if ($nextSlide) {
                    gsap.killTweensOf($nextSlide.querySelectorAll('.slide__content__text, .title'));

                    tl.fromTo(
                        $nextSlide.querySelectorAll('.slide__content__text, .title'),
                        {
                            y: -50,
                            autoAlpha: 0,
                        },
                        {
                            y: 0,
                            autoAlpha: 1,
                            stagger: 0,
                            duration: 0.35,
                        },
                        'text',
                    );
                }
            }
        },
    },
};
</script>
